<div class="no-data">
  <span *ngIf="title" class="no-data__title">{{title | translate}}</span>
  <span *ngIf="subTitle" class="no-data__description">{{subTitle | translate}}</span>
</div>
